export const ONBOARDING_ROUTE_NAMES = {
  ENTRY: 'onboardingEntry',
  PASSWORD: 'onboardingPassword',
  DONE: 'onboardingDone',
  TOKEN_EXPIRED: 'tokenExpired',
}
